import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";

export const GET_PAYER_GROUPS_LIST = "GET_PAYER_GROUPS_LIST";

export const service = async () => {
  const options: object = {
    url: `/api/PayerGroup/GetPayerGroups/`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_PAYER_GROUPS_LIST, service, mock);
